import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProjectUpdateProject } from '@store/flow-data/project';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { GetProjectByIdFailure, GetProjectByIdRequest, GetProjectByIdSuccess } from './actions';
import { GetProjectByIdService } from './service';

@Injectable()
export class GetProjectByIdEffects {
  private readonly actions$ = inject(Actions);
  private readonly getProjectByIdService = inject(GetProjectByIdService);

  getProjectById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetProjectByIdRequest),
      switchMap(({ parameters }) =>
        this.getProjectByIdService.getProjectById(parameters).pipe(
          switchMap(data => [ProjectUpdateProject({ data }), GetProjectByIdSuccess({ data })]),
          catchError(error => of(GetProjectByIdFailure({ error })))
        )
      )
    )
  );

}
